import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { ApiError } from 'api/core/ApiError';
import { FirmsService } from 'api/services/FirmsService';
import { DAILY_NAV_RECORDS_BY_FIRM_QUERY_KEY } from 'common/constants/services/firms';

const useGenerateDailyNavRecords = (firmId: number | undefined) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (date?: string) => FirmsService.apiFirmsDailyNavGenerateCreate(String(firmId), date),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: [DAILY_NAV_RECORDS_BY_FIRM_QUERY_KEY] });
      enqueueSnackbar(
        `Generated ${data.created_count} new Daily NAV record(s) for ${data.date} (${data.skipped_count} already existed).`,
        { variant: 'success' }
      );
    },
    onError: (error: unknown) => {
      let message = 'Failed to generate Daily NAV records.';
      if (error instanceof ApiError && typeof error.body === 'object' && error.body) {
        const { detail } = error.body as Record<string, unknown>;
        if (typeof detail === 'string') {
          message = detail;
        }
      } else if (error instanceof Error && error.message) {
        message = error.message;
      }
      enqueueSnackbar(message, { variant: 'error' });
    },
  });
};

export default useGenerateDailyNavRecords;
